import { Decimal } from 'decimal.js'

import type { TPeriodicidadePagamentoEnum } from '@/types/simulacao'

export type TGrupoParcela = {
  valor: number
  data: string | null
}

export type TGrupoParcelas = TGrupoParcela[]

export type TGrupoMensais = {
  valor: number
  quantidade: number
  dataInicio: string | null
  dataFim: string | null
}

export type TGrupoMensaisPosConclusao = {
  valor: number
  quantidade: number
  dataInicio: string | null
  dataFim: string | null
}

export type TGrupoIntermediarias = {
  valor: number
  parcelas: Array<Pick<TGrupoParcela, 'data'>>
  periodicidade: TPeriodicidadePagamentoEnum
}

export interface IProcessadorValoresDecimal {
  calcularValorPosConclusao: (grupo: TGrupoMensaisPosConclusao | null | undefined) => number
  calcularTotalEntradas: (entradas: TGrupoParcela[] | null | undefined) => number
  calcularTotalMensais: (mensais: TGrupoMensais[] | null | undefined) => number
  calcularTotalIntermediarias: (intermediarias: TGrupoIntermediarias[] | null | undefined) => number
}

export class ProcessadorValoresDecimal implements IProcessadorValoresDecimal {
  calcularValorPosConclusao(grupo: TGrupoMensaisPosConclusao | null | undefined): number {
    return new Decimal(grupo?.valor ?? 0).times(grupo?.quantidade ?? 0).toNumber()
  }

  calcularTotalEntradas(entradas: TGrupoParcela[] | null | undefined): number {
    return entradas?.reduce((acc, g) => acc.plus(g.valor), new Decimal(0)).toNumber() ?? 0
  }

  calcularTotalMensais(mensais: TGrupoMensais[] | null | undefined): number {
    return (
      mensais?.reduce((acc, g) => acc.plus(new Decimal(g.valor).times(g.quantidade)), new Decimal(0)).toNumber() ?? 0
    )
  }

  calcularTotalIntermediarias(intermediarias: TGrupoIntermediarias[] | null | undefined): number {
    return (
      intermediarias
        ?.reduce((acc, g) => acc.plus(new Decimal(g.valor).times(g.parcelas.length)), new Decimal(0))
        .toNumber() ?? 0
    )
  }
}
